
import { Header, Icon } from "semantic-ui-react";
import { HolidayScheduleTable } from "./subcomponents/HolidayScheduleTable";
import AddHolidayScheduleForm from "./subcomponents/AddHolidayScheduleForm";
import { useState } from "react";
import { Modal } from "dyl-components";
import { useDispatch, useSelector } from "react-redux";
import pbxConfigActions from "actions/pbx_config";

const HolidaySchedule = () => {
    const [isAddHolidayScheduleFormOpen, setIsAddHolidayScheduleFormOpen] = useState(false);
    const { isReadingHolidaySchedules, holidaySchedulesCount, holidaySchedule } = useSelector((state) => state.pbx_config);
    const [actionType, setActionType] = useState("");

    const dispatch = useDispatch();

    const onEdit = async (id) => {
        setActionType("edit");
        setIsAddHolidayScheduleFormOpen(true);
        await dispatch(pbxConfigActions.getHolidaySchedule(id));
    }

    const onDuplicate = async (id) => {
        setActionType("duplicate");
        setIsAddHolidayScheduleFormOpen(true);
        await dispatch(pbxConfigActions.getHolidaySchedule(id));
    }
    return (
        <div>
            <Header as="h2" color="primary" disabled={isReadingHolidaySchedules || holidaySchedulesCount >= 10}>
                <span>
                    {
                        <Icon
                            link
                            onClick={() => {
                                setIsAddHolidayScheduleFormOpen(true);
                            }}
                            disabled={isReadingHolidaySchedules || holidaySchedulesCount >= 10}
                            className="fas fa-plus-circle"
                            color="primary"
                        />
                    }
                    Holiday Schedule
                </span>
            </Header>
            <HolidayScheduleTable onEdit={onEdit} onDuplicate={onDuplicate} />
            <Modal open={isAddHolidayScheduleFormOpen} onClose={() => { setIsAddHolidayScheduleFormOpen(false); setActionType(""); }} size="large">
                <AddHolidayScheduleForm
                    handleClose={() => { setIsAddHolidayScheduleFormOpen(false); setActionType(""); }}
                    holidaySchedule={holidaySchedule}
                    actionType={actionType}
                />
            </Modal>
        </div>
    );
};

export default HolidaySchedule;